import { FunctionComponent, memo, useContext, useMemo } from 'react';
import { ChannelContext, ConfigContext, UserContext } from '../../../context';
import { useAppSelector } from '../../hooks';
import { Select } from '../Select';

interface ChannelSwitcherProps {
  onChange: (channelId: number) => void;
}

export const ChannelSwitcher: FunctionComponent<ChannelSwitcherProps> = memo(({ onChange }) => {
  const { image } = useContext(ChannelContext);

  const { channels } = useAppSelector(({ channels }) => channels);

  const { channelId } = useContext(UserContext).userInfo.userData;

  const { channelLogos } = useContext(ConfigContext).config.elements;

  const channelItems = useMemo(() => {
    return (
      channels.map(({ id, name, image }) => ({
        id,
        title: name,
        logoUrl: channelLogos.find(({ channelId }) => channelId === id)?.logoUrl,
        iconUrl: image?.url,
      })) ?? []
    );
  }, [channelLogos, channels]);

  const logoUrl = useMemo(
    () => channelLogos.find((logo) => logo.channelId === channelId)?.logoUrl,
    [channelId, channelLogos]
  );

  return (
    <Select
      selectedItemId={channelId}
      items={channelItems}
      logoUrl={logoUrl}
      iconUrl={image?.url}
      onChange={(channelId) => onChange(channelId as number)}
      disabled={channels.length === 1}
      noBorder
    />
  );
});
